import { connect } from 'react-redux';
import { IHttpApi } from '@cian/http-api';
import * as R from 'ramda';
import { IAppState, IUserSignedIn } from '../../../common/state';
import { PushNotification } from './index';

export interface IProps {
  applicationServerKey: string;
  baseUrl: string;
  currentPage?: number;
  currentSubdomain: string;
  expiresInSevenDays: number;
  httpApi: IHttpApi;
  isPushEnabled: boolean;
  userId: string | number;
  notificationPermission: string;
}

export const mapStateToProps = (state: IAppState) => {
  const { config, httpApi, currentSubdomain, user } = state;

  const applicationServerKey = config.get<string>('applicationServerKey') || '';
  const baseUrl = config.get('push.browserUrl') as string;
  const currentPage = R.pathOr(1, ['results', 'jsonQuery', 'page', 'value'], state);
  const expiresInSevenDays = 7 * 24;
  const isPushEnabled = config.get<boolean>('push.enabled') || false;
  let notificationPermission = 'default';

  if ('Notification' in window && currentSubdomain === 'www') {
    notificationPermission = Notification.permission;
  }

  return {
    applicationServerKey,
    baseUrl,
    currentPage,
    currentSubdomain,
    expiresInSevenDays,
    httpApi,
    isPushEnabled,
    notificationPermission,
    userId: (user as IUserSignedIn).userId || '',
  };
};

export const PushContainer = connect<IProps, {}>(mapStateToProps)(PushNotification);
